import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Actualidad from "../pages/actualidad/page";
import AviacionRD from "../pages/aviacion-rd/page";
import Aeropuertos from "../pages/aeropuertos/page";
import Aerolineas from "../pages/aerolineas/page";
import Estadisticas from "../pages/estadisticas/page";
import EstadisticasAerolineas from "../pages/estadisticas-aerolineas/page";
import EstadisticasAeropuertos from "../pages/estadisticas-aeropuertos/page";
import Publicidad from "../pages/publicidad/page";
import Contacto from "../pages/contacto/page";
import SobreMi from "../pages/sobre-mi/page";
import Turismo from "../pages/turismo/page";
import Articulo from "../pages/articulo/page";
import Archivo from "../pages/archivo/page";
import Admin from "../pages/admin/page";
import ShortRedirect from "../pages/shortRedirect/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/actualidad",
    element: <Actualidad />,
  },
  {
    path: "/aviacion-rd",
    element: <AviacionRD />,
  },
  {
    path: "/aeropuertos",
    element: <Aeropuertos />,
  },
  {
    path: "/aerolineas",
    element: <Aerolineas />,
  },
  {
    path: "/estadisticas",
    element: <Estadisticas />,
  },
  {
    path: "/estadisticas-aerolineas",
    element: <EstadisticasAerolineas />,
  },
  {
    path: "/estadisticas-aeropuertos",
    element: <EstadisticasAeropuertos />,
  },
  {
    path: "/publicidad",
    element: <Publicidad />,
  },
  {
    path: "/turismo",
    element: <Turismo />,
  },
  {
    path: "/sobre-mi",
    element: <SobreMi />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/articulo/:slug",
    element: <Articulo />,
  },
  {
    path: "/s/:code",
    element: <ShortRedirect />,
  },
  {
    path: "/archivo",
    element: <Archivo />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;